import React from "react";
class AccordionApp extends React.Component {
    render() {
        const title = '';
        const hiddenTexts = [{
            label: 'What is Little Billionaires?',
            value: 'Little Billionaires is a digital NFT collection of 7,777 unique 3D art characters. Little Billionaires are a generative 3D art NFT project with the main focus on added value for the holder. Little Billionaires provides the customer with a state-of-the-art ecosystem circulating around the  $LITTLE token, which finds its added value in a variety of use cases. Participating in a staking program that rewards NFT holders daily with the $LITTLE utility token is just one of many incomparable use cases. Holding $LITTLE will reward you with MATIC'
        },
        {
            label: 'How does the staking program work?',
            value: 'A section called “staking” is available to all NFT holders. In this, NFTs can be staked and held. Staked NFTs are rewarded with a certain number of $LITTLE tokens each day (between 70 and 300), since they are securing the network . These $LITTLE Token can either be held at their or locked to earn MATIC on a daily bases.'
        },
        {
            label: 'What is $LITTLE Token?',
            value: '$LITTLE is the Little Billionaires utility token. Earn $LITTLE as an NFT holder through staking, get rewarded with MATIC tokens every day for owning your $LITTLE and enjoy many exclusive benefits associated with this token.'
        },
        {
            label: 'How can I receive my staking profits?',
            value: 'Staking profits are automatically added to your balance on a daily basis. You always get your staking profits in $LITTLE tokens. You can either keep them or lock a minimum of 2,000$LITTLE to get rewarded in MATIC every day. Holding $LITTLE will reward you in MATIC (polygon) every day. You can always withdraw these profits.'
        },
        {
            label: 'When will the minting be available?',
            value: 'The mining start is currently to be announced.'
        },
        {
            label: 'How can I get whitelisted?',
            value: 'You can find detailed instructions on how to get a whitelist spot in our Discord Channel. In short, it is important to bring new active members to the Discord server, push our social media channels and be an active community member. If you participate in fan art contests or boost the server, you increase the probability of getting a whitelist spot.'
        },
        {
            label: 'How much will a Little Billionaire cost?',
            value: 'The minting price is to be announced.'
        },
        {
            label: 'How many Little Billionaires will be available to mint?',
            value: '7,777'
        },
        {
            label: 'Will there be a presale?',
            value: 'Yes! There will be a presale..'
        }];
        return (
            <div>
                <Header title={title} />
                <Accordion hiddenTexts={hiddenTexts} />
            </div>
        );
    }
}

class Header extends React.Component {
    render() {
        return (
            <h1>{this.props.title}</h1>
        );
    }
}

class Accordion extends React.Component {
    render() {
        return (
            <div className="accordion">
                {this.props.hiddenTexts.map((hiddenText) => <AccordionItem key={hiddenText.label} hiddenText={hiddenText} />)}
            </div>
        );
    }
}

class AccordionItem extends React.Component {
    
    constructor(props) {
        super(props);
        this.handleToggleVisibility = this.handleToggleVisibility.bind(this);
        this.state = {
            visibility: false
        }
    }
    
    handleToggleVisibility() {
        this.setState((prevState) => {
            return {
                visibility: !prevState.visibility,
            }
        })
    }
    render() {
        const activeStatus = this.state.visibility ? 'active' : ''

        return (
            <div>
                <button className="accordion__button" onClick={this.handleToggleVisibility}>{this.props.hiddenText.label}<span className={this.state.visibility? 'fas fa-minus': 'fas fa-plus'}></span></button>
                <p className={`accordion__content ${activeStatus}`}>
                {
                    this.props.hiddenText.value
                }
                </p>
                
            </div>
        );
    }
}

export default AccordionApp;